import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { TruncatedTextDiv } from './search-footer-links.styled';
export var ForwardedRefToolTipTag = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(TruncatedTextDiv, _extends({}, props, {
    ref: ref
  }));
});